import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 138,
	height: 138,
	viewBox: "0 0 138 138",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 69,
			cy: 69,
			r: 69,
			fill: "#A9D9FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.356 70.6397C75.7465 73.5488 74.1937 77.1398 71.2219 78.5604C68.2501 79.981 64.7137 78.774 63.3232 75.8648C61.9324 72.9554 63.2143 69.4456 66.1861 68.025C69.1579 66.6047 72.9652 67.7306 74.356 70.6397Z",
			fill: "#00205B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.356 40.133C75.7465 43.0422 74.1937 46.6332 71.2219 48.0537C68.2501 49.4741 64.7137 48.2673 63.3232 45.3579C61.9324 42.4488 63.2143 38.9389 66.1861 37.5183C69.1579 36.0977 72.9652 37.2236 74.356 40.133Z",
			fill: "#BA0C2F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.8617 26.1822C85.1681 28.9152 83.7161 32.3353 80.8717 33.695C78.0467 35.0453 74.6958 33.8949 73.3809 31.1435C72.0657 28.3923 73.2747 25.0621 76.0997 23.7118C78.9386 22.3547 82.5528 23.4441 83.8617 26.1822Z",
			fill: "#4A8CBF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.1283 11.0206C74.4346 13.7535 72.9827 17.1738 70.1382 18.5334C67.3135 19.8837 63.9626 18.7332 62.6474 15.9819C61.3322 13.2305 62.5415 9.90036 65.3665 8.55007C68.2051 7.19312 71.8194 8.28258 73.1283 11.0206Z",
			fill: "#4A8CBF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.4585 60.5464L63.4585 60.5464C62.1048 57.7147 63.351 54.293 66.2508 52.9068C69.1574 51.5174 72.87 52.6254 74.2207 55.4509C75.5698 58.2735 74.0666 61.7809 71.1572 63.1716C68.2574 64.5575 64.812 63.3783 63.4585 60.5464Z",
			fill: "#00205B",
			stroke: "#B89D46",
			strokeWidth: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.4734 55.4509L89.6062 55.3874L89.4734 55.4509C90.8226 58.2735 89.3194 61.7809 86.41 63.1716C83.5105 64.5575 80.065 63.3783 78.7113 60.5464C77.3578 57.7147 78.604 54.293 81.5038 52.9068C84.4104 51.5174 88.1231 52.6254 89.4734 55.4509Z",
			fill: "#00205B",
			stroke: "#B89D46",
			strokeWidth: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.9666 55.4509L58.9666 55.4509C60.316 58.2735 58.8126 61.7808 55.9034 63.1716C53.0036 64.5575 49.5582 63.3783 48.2045 60.5464C46.851 57.7147 48.0972 54.293 50.997 52.9068C53.9036 51.5174 57.6162 52.6254 58.9666 55.4509Z",
			fill: "#00205B",
			stroke: "#B89D46",
			strokeWidth: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.356 85.8923C75.7465 88.8014 74.1937 92.3924 71.2219 93.813C68.2501 95.2333 64.7137 94.0266 63.3232 91.1172C61.9324 88.208 63.2143 84.6982 66.1861 83.2776C69.1579 81.857 72.9652 82.9829 74.356 85.8923Z",
			fill: "#00205B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.356 101.145C75.7465 104.054 74.1937 107.645 71.2219 109.066C68.2501 110.486 64.7137 109.28 63.3232 106.37C61.9324 103.461 63.2143 99.9511 66.1861 98.5305C69.1579 97.1099 72.9652 98.2358 74.356 101.145Z",
			fill: "#00205B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.1509 96.061C93.5414 98.9704 91.9887 102.561 89.0169 103.982C86.045 105.402 82.5086 104.196 81.1181 101.286C79.7274 98.377 81.0092 94.8669 83.981 93.4465C86.9528 92.026 90.7602 93.1519 92.1509 96.061Z",
			fill: "#00205B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.7776 83.3502C101.168 86.2593 99.6156 89.8503 96.6438 91.2709C93.672 92.6915 90.1356 91.4845 88.7451 88.5753C87.3543 85.6659 88.6361 82.1561 91.608 80.7355C94.5798 79.3152 98.3871 80.4408 99.7776 83.3502Z",
			fill: "#00205B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1019 98.6031C60.4927 101.512 58.9397 105.103 55.9681 106.524C52.9963 107.944 49.4599 106.737 48.0691 103.828C46.6786 100.919 47.9605 97.409 50.9323 95.9884C53.9041 94.5681 57.7114 95.6937 59.1019 98.6031Z",
			fill: "#00205B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.934 88.434C50.3245 91.3434 48.7718 94.9344 45.7999 96.3548C42.8281 97.7754 39.2917 96.5683 37.9012 93.6592C36.5107 90.7498 37.7923 87.2399 40.7641 85.8196C43.7359 84.399 47.5433 85.5249 48.934 88.434Z",
			fill: "#00205B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.0805 116.53C75.3866 119.263 73.9349 122.683 71.0904 124.043C68.2655 125.393 64.9145 124.242 63.5996 121.491C62.2844 118.74 63.4935 115.41 66.3184 114.059C69.1573 112.702 72.7716 113.792 74.0805 116.53Z",
			fill: "#4A8CBF"
		})
	]
});
export default SvgHomeLogo;
